import React from "react";
import { maintenaceDetailstyle } from "../../../styles/maintenanceDetailstyle";
import { themeService } from "../../../../../theme/service/activeTheme.service";
import { languageService } from "../../../../../Language/language.service";
import { Row, Col } from "reactstrap";
import ImageArea from "../../../../Common/ImageArea";
import AudioArea from "../../../MaintenanceDetail/AudioComponent/AudioArea";
import DocumentsArea from "components/Common/DocumentsArea/index";

export const ExecutionImageArea = ({ selectedRowData }) => {
  let selectedRowImg =
    (selectedRowData &&
      selectedRowData.tasks.flatMap((task) =>
        task.maintenance.flatMap((maintenance) => {
          !maintenance.imgList && (maintenance.imgList = []);
          return maintenance.imgList.map((img) => img);
        }),
      )) ||
    null;
  return (
    <React.Fragment>
      {" "}
      <div style={themeService(maintenaceDetailstyle.fieldHeading)}> {languageService("Images")}: </div>
      <div style={{ ...themeService(maintenaceDetailstyle.MaintenanceDescriptionContainer), border: "1px solid grey" }}>
        <Row>
          {selectedRowImg && (
            <Col md="12" style={{ display: "flex", flexWrap: "wrap", overflow: "auto" }}>
              <ImageArea path="applicationresources" imagesList={selectedRowImg ? selectedRowImg : ""} imageHeight={"100px"} />
            </Col>
          )}
        </Row>
      </div>
    </React.Fragment>
  );
};

export const ExecutionDocArea = ({ selectedRowData }) => {
  let selectedRowImg =
    (selectedRowData &&
      selectedRowData.tasks.flatMap((task) =>
        task.maintenance.flatMap((maintenance) => {
          !maintenance.docList && (maintenance.docList = []);
          return maintenance.docList.map((img) => img.imgName);
        }),
      )) ||
    null;
  return (
    <React.Fragment>
      {" "}
      <div style={themeService(maintenaceDetailstyle.fieldHeading)}> {languageService("Documents")}: </div>
      <div style={{ ...themeService(maintenaceDetailstyle.MaintenanceDescriptionContainer), border: "1px solid grey" }}>
        <Row>
          {selectedRowImg && (
            <Col md="12">
              <DocumentsArea
                path="assetDocuments"
                documentList={selectedRowImg ? selectedRowImg : ""}
                imageHeight={"100px"}
                disallowDelete={true}
                disableHeader={true}
              />
            </Col>
          )}
        </Row>
      </div>
    </React.Fragment>
  );
};

export const ExecutionVoiceArea = ({ selectedRowData }) => {
  let selectedRowVoice =
    (selectedRowData &&
      selectedRowData.tasks.flatMap((task) =>
        task.maintenance.flatMap((maintenance) => {
          !maintenance.voiceList && (maintenance.voiceList = []);
          return maintenance.voiceList.map((voice) => voice);
        }),
      )) ||
    null;
  return (
    <Row>
      {selectedRowVoice ? (
        <Col md="12">
          <AudioArea audio={selectedRowVoice ? selectedRowVoice : ""} />
        </Col>
      ) : null}
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/DetailViews/ExecutionDetail/ExecutionDetails.jsx